"use client";
import { jsx as c } from "react/jsx-runtime";
import u, { createContext as m, useContext as i } from "react";
import { useBoolean as l } from "../hooks/use-boolean.js";
const t = m(
  void 0
);
function p({ children: e }) {
  const [s, o] = u.useState(null), { value: n, setTrue: r, setFalse: a } = l(!1);
  return /* @__PURE__ */ c(
    t.Provider,
    {
      value: { selectedItem: s, selectItem: o, isOpen: n, onOpen: r, onClose: a },
      children: e
    }
  );
}
const v = () => {
  const e = i(t);
  if (!e)
    throw new Error("useMessageAttachments must be used within a MessageAttachmentsProvider");
  return e;
};
export {
  p as MessageAttachmentsProvider,
  v as useMessageAttachments
};
